import { Component, OnInit, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

declare var i18nVS: any;
declare var jsonGetContentURL: any;
declare var privaciPolicyId: string;
declare var idCiudadLiferay: string; // El id de la ciudad en la que estamos

declare function openModal(nameModal: string): any;
declare function closeModal(nameModal: string): any;

declare function getContentsFunction(): any;
declare function sendFormFunction(idForm, finalURL): any;

declare var SendPlainFormEmailReclamacion: any;
declare var portletNameFormReclamacion: any;
declare var responsesMap;

@Component({
    selector: 'app-iniciar-reclamacion',
    templateUrl: './iniciar-reclamacion.component.html',
    styleUrls: ['./iniciar-reclamacion.component.css']
})

export class AppComponent implements OnInit {
    @ViewChild('sagModalContent') sagModalContent: ElementRef;

    i18nL = i18nVS;
    actionForm = ''; // Action del formulario
    portletName = ''; // Nombre del portlet
    idCiudad = '0';
    isRabat = false;

    // Variables de la modal
    modalVisible = false; // Si esta modal es visible o no
    showSpinner = '';
    URLContenido = '';
    theHtmlString = '';

    CadaCuanto = 30; // En minutos
    MinutosTotales = 0;
    Horas = ['00:00'];
    Huecos = (24 * 60) / this.CadaCuanto;

    // Validaciones
    nombreClass = '';
    apellidosClass = '';
    documentoClass = '';
    telefonoClass = '';
    direccionClass = '';
    CPClass = '';
    fechaClass = '';
    lineaClass = '';
    emailClass = '';
    hourClass = '';
    placeClass = '';
    natureOfTheComplaintClass = '';
    preferredContactMethodClass = '';
    busNumberClass = '';
    descripcionClass = '';
    aceptarAcuerdoClass = 'invisible';
    acceptConditionsClass = 'invisible';

    responseFormSpinner = 'invisible';
    successResponseForm = 'invisible';
    errorResponseForm = 'invisible';
    showResponse = false;
    responseText = '';
    responseMapKey = 0;

    public leerDatos(PLID: string): Observable<Response> {
        if (typeof i18nVS !== 'undefined') {
            var body = this.portletName + 'contentPLID=' + PLID;
            const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // Set content type to JSON
            const options = new RequestOptions({ headers: headers }); // Create a request option
            return this.http.post(jsonGetContentURL, body, options);
        }
    }

    public validarFormulario() {
        var validado = true;
        if ((<HTMLInputElement>document.getElementById('nombre')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('nombre')).placeholder = this.i18nL.form_campoObligatorio;
            this.nombreClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('apellidos')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('apellidos')).placeholder = this.i18nL.form_campoObligatorio;
            this.apellidosClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('telefono')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('telefono')).placeholder = this.i18nL.form_campoObligatorio;
            this.telefonoClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('email')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('email')).placeholder = this.i18nL.form_campoObligatorio;
            this.emailClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('date')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('date')).placeholder = this.i18nL.form_campoObligatorio;
            this.fechaClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('hour')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('hour')).placeholder = this.i18nL.form_campoObligatorio;
            this.hourClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('place')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('place')).placeholder = this.i18nL.form_campoObligatorio;
            this.placeClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('natureOfTheComplaint')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('natureOfTheComplaint')).placeholder = this.i18nL.form_campoObligatorio;
            this.natureOfTheComplaintClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('preferredContactMethod')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('preferredContactMethod')).placeholder = this.i18nL.form_campoObligatorio;
            this.preferredContactMethodClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('linea')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('linea')).placeholder = this.i18nL.form_campoObligatorio;
            this.lineaClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('busNumber')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('busNumber')).placeholder = this.i18nL.form_campoObligatorio;
            this.busNumberClass = 'inputError';
            validado = false;
        }
        if ((<HTMLInputElement>document.getElementById('descripcion')).value.trim() === '') {
            (<HTMLInputElement>document.getElementById('descripcion')).placeholder = this.i18nL.form_campoObligatorio;
            this.descripcionClass = 'inputError';
            validado = false;
        }
        if (!(<HTMLInputElement>document.getElementById('agreements')).checked) {
            this.aceptarAcuerdoClass = 'visibleError';
            validado = false;
        }
        if (validado) {
            this.showResponseForm();
            this.responseMapKey = sendFormFunction('iniciarReclamacionForm', SendPlainFormEmailReclamacion);
        }
        return false;
    }

    public clearClass(inputId: string) {
        if (inputId == 'agreements') {
            if ((<HTMLInputElement>document.getElementById('agreements')).checked) {
                this.aceptarAcuerdoClass = 'invisible';
            } else {
                this.aceptarAcuerdoClass = 'visibleError';
            }
        } else {
            if ((<HTMLInputElement>document.getElementById(inputId)).value.trim() !== '') {
                this.nombreClass = '';
            }
        }
    }

    public getContents(PLID: string) {
        this.leerDatos(PLID).subscribe(res => this.comprobandoJson(res), (err) => this.errorEnElJson(), () => this.allFine());
    }

    public getContentsFunction() {
        if (this.theHtmlString == '') {
            this.getContents(privaciPolicyId);
        }
    }

    public comprobandoJson(res) {
        this.showSpinner = 'invisible';
        this.theHtmlString = res._body;
    }

    public errorEnElJson() {
        // this.onGeneralError.emit(true);
        //console.lo('Error en la carga del contenido');
    }

    public allFine() {
        //console.lo('Contenido creado');
    }

    public showResponseForm() {
        this.resetView();
        this.showResponse = true;
        this.checkForResponseCorutine();
        this.responseFormSpinner = '';
        this.successResponseForm = 'invisible';
        this.errorResponseForm = 'invisible';
        this.responseText = '';
    }

    private checkForResponseCorutine() {
        if (typeof responsesMap.get(this.responseMapKey) != 'undefined' && responsesMap.get(this.responseMapKey) != '' && this.showResponse) {
            this.responseFormSpinner = 'invisible';
            var actualResponse = JSON.parse(responsesMap.get(this.responseMapKey));
            if (actualResponse.success != null) {
                this.successResponseForm = '';
                this.responseText = actualResponse.success;
            } else {
                this.errorResponseForm = '';
                this.responseText = actualResponse.error;
            }
            this.responseMapKey = -1;
        } else {
            setTimeout(() => this.checkForResponseCorutine(), 250);
        }
    }

    public resetView() {
        this.responseFormSpinner = 'invisible';
        this.successResponseForm = 'invisible';
        this.errorResponseForm = 'invisible';
        this.showResponse = false;
        this.responseText = '';
    }

    public toggleModal() {
        if (!this.modalVisible) {
            this.modalVisible = true;
            openModal('modalAgreements');
        } else {
            this.modalVisible = false;
            closeModal('modalAgreements');
        }
    }

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit() {
        this.portletName = portletNameFormReclamacion;
        this.idCiudad = idCiudadLiferay;
        this.isRabat = this.idCiudad === '5';
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http, private sanitizer: DomSanitizer, private renderer: Renderer2) { }
}



// WEBPACK FOOTER //
// ./src/app/iniciar-reclamacion.component.ts